import { DocumentNode, gql } from '@apollo/client';
import { Stack, Text, Wrap } from '@chakra-ui/react';
import * as React from 'react';

import { EventAudience } from '@/components/EventAudience';
import { EventLocation } from '@/components/EventLocation';
import { EventTime } from '@/components/EventTime';
import { CalendarIcon } from '@/imports/ui/chakra/feather';
import { AddToCalendarMenu } from '@/imports/ui/components/event/AddToCalendarMenu';
import { useFeatureFlags } from '@/imports/ui/hooks/useFeatureFlags';

import { EventScheduleInfo_EventFragment } from './graphql-types/EventScheduleInfo_EventFragment';

export const EventScheduleInfo: React.FC<{
  event: EventScheduleInfo_EventFragment;
  showAddToCalendar?: boolean;
}> & {
  eventFragment: DocumentNode;
} = ({ event, showAddToCalendar }) => {
  const { startDate, endDate } = event;
  const { hideDateAndTimeForCourses } = useFeatureFlags();
  const hideDateAndTime =
    hideDateAndTimeForCourses && event.isCourseWorkshop === true;

  return (
    <Stack>
      {!hideDateAndTime && (
        <Wrap align="center" spacing={2}>
          <Stack direction="row" alignItems="center">
            <CalendarIcon />
            <Text>
              {startDate && endDate ? (
                <EventTime
                  startDate={startDate}
                  endDate={endDate}
                  eventTimezone={event.timeZone ?? undefined}
                />
              ) : (
                'TBD'
              )}
            </Text>
          </Stack>
          {showAddToCalendar && <AddToCalendarMenu eventId={event._id} />}
        </Wrap>
      )}

      <Stack>
        <EventLocation event={event} />

        <EventAudience event={event} noOfLines={1} />
      </Stack>
    </Stack>
  );
};

EventScheduleInfo.eventFragment = gql`
  fragment EventScheduleInfo_EventFragment on EventV2 {
    _id
    startDate
    endDate
    timeZone
    isCourseWorkshop
    ...EventAudience_EventFragment
    ...EventLocation_EventFragment
  }
  ${EventAudience.eventFragment}
  ${EventLocation.eventFragment}
`;
